var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M60 0C93.1367 0 120 26.8628 120 60C120 93.1367 93.1367 120 60 120C26.8628 120 0 93.1367 0 60C0 26.8628 26.8628 0 60 0Z",
    fill: "#F3564D"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M60.0001 1.68652C92.2057 1.68652 118.314 27.7944 118.314 60.0001C118.314 92.2057 92.2057 118.314 60.0001 118.314C27.7944 118.314 1.68652 92.2057 1.68652 60.0001C1.68652 27.7944 27.7944 1.68652 60.0001 1.68652Z",
    stroke: "#F3564D",
    strokeWidth: 2.7,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M60.0001 1.68652C92.2057 1.68652 118.314 27.7944 118.314 60.0001C118.314 92.2057 92.2057 118.314 60.0001 118.314C27.7944 118.314 1.68652 92.2057 1.68652 60.0001C1.68652 27.7944 27.7944 1.68652 60.0001 1.68652Z",
    stroke: "#F3564D",
    strokeWidth: 2.7,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M60.0008 75.1184C56.6372 75.1184 53.9102 72.3914 53.9102 69.0274V31.5818C53.9102 28.2178 56.6372 25.4907 60.0008 25.4907C63.3648 25.4907 66.0915 28.2178 66.0915 31.5818V69.0274C66.0915 72.3914 63.3648 75.1184 60.0008 75.1184Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M59.9997 94.5091C56.2622 94.5091 53.2324 91.4797 53.2324 87.7419C53.2324 84.0044 56.2622 80.9746 59.9997 80.9746C63.7371 80.9746 66.767 84.0044 66.767 87.7419C66.767 91.4797 63.7371 94.5091 59.9997 94.5091Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.eeb3e8e283be86f9672d10dddc5bdd19.svg";
export { ForwardRef as ReactComponent };